"use strict";
import React from "react";
import _ from "underscore";
import ReactUtils from "../../react_utils";
const bem = ReactUtils.makeBem("document-browser");
export default React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  explicitHeightStyle: function() {
    if (this.props.tmsObjects.length > 5) {
      return { height: 185 };
    } else {
      return {};
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: bem("__assign-documents-selector"),
        style: this.explicitHeightStyle()
      },
      /* @__PURE__ */ React.createElement("span", { className: bem("__assign-documents-selector-label") }, this.props.label),
      _.map(this.props.tmsObjects, this.props.tmsObjectDetailsFunction)
    );
  }
});
